import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private toastr: ToastrService,
    private zone: NgZone
  ) {}

  handleError(error: any): void {
    // Log the error to the console for developers
    console.error('An error occurred:', error);

    // Show a user-friendly notification
    // We run this inside NgZone to ensure it's properly executed in Angular's context
    this.zone.run(() => {
      this.toastr.error(
        'An unexpected error occurred. Please try again later.',
        'Error'
      );
    });
  }
}
